import { AppUiErrorCode } from 'core/services/error/error-code.model'

export class UiError {
	uiCode!: AppUiErrorCode

	constructor(uiCode: AppUiErrorCode) {
		this.uiCode = uiCode
	}
}
